import * as Yup from 'yup';

const yupSequence = <T>(name: string, ...schemas: ReadonlyArray<Yup.ISchema<any>>): Yup.TestConfig<T> => {
  return {
    name,
    test: async (value, context) => {
      try {
        for (const schema of schemas) {
          await schema.validate(value, { context });
        }
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          // for some reason the original error's "path" is empty
          return context.createError({ message: error.message });
        }
        throw error;
      }
      return true;
    }
  };
};

export default yupSequence;
